export const PERIODS = {
  '24h': { label: '24H', hours: 24 },
  '7d': { label: '7D', hours: 7 * 24 },
  '30d': { label: '30D', hours: 30 * 24 },
  all: { label: 'All', hours: Infinity },
} as const;

export type Period = keyof typeof PERIODS;
